// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import HourglassTwoToneSvg from "@fishx/icons-svg/es/asn/HourglassTwoTone";
import FishxIcon from '../components/FishxIcon';

var HourglassTwoTone = function HourglassTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: HourglassTwoToneSvg
  }));
};

HourglassTwoTone.displayName = 'HourglassTwoTone';
export default React.forwardRef(HourglassTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/HourglassTwoTone.js
// module id = 2946
// module chunks = 0